import { PERMISSIONS } from '../common/auth/AuthorizeConstant'
import ATDropdownActionButton from '../common/formComponent/ATDropdownActionButton'

const getTenantAction = (
  value: any,
  onEditHandler: any,
  onDisableHandler: any,
) => {
  return [
    {
      name: 'tenant.edit_admin',
      functionName: () => onEditHandler(value?.userId),
      permission: PERMISSIONS.EDIT_TENANT_ADMIN_DETAILS,
    },
    {
      name: value?.isActive ? 'tenant.deactivate' : 'tenant.activate',
      functionName: () => onDisableHandler(value?.userId),
      permission: PERMISSIONS.UPDATE_TENANT_ADMIN_ACCESS,
    },
  ]
}

export const TenantAdminColumns = (
  onEditHandler: any,
  onDisableHandler: any,
) => [
  {
    key: 'userName',
    title: 'common.name',
  },
  {
    key: 'email',
    title: 'common.email_id',
  },
  {
    key: 'action',
    style: { width: '20px', textAlign: 'end' },
    render: (_: any, value: any) => (
      <div className="text-end">
        <ATDropdownActionButton
          id="userDropdownAction"
          size="sm"
          title={'common.actions'}
          actionArray={getTenantAction(value, onEditHandler, onDisableHandler)}
        />
      </div>
    ),
  },
]

export const tenantBasicDetails = [
  { key: 'companyName', title: 'common.company_name' },
  { key: 'city', title: 'common.city' },
  { key: 'address', title: 'common.address' },
  { key: 'zipCode', title: 'common.zip_code' },
  { key: 'state', title: 'common.state' },
  { key: 'contactNumber', title: 'common.contact_no' },
  { key: 'country', title: 'common.country' },
  { key: 'email', title: 'common.email_id' },
  { key: 'domain', title: 'tenant.domain_names' },
  { key: '', title: '' },
]

export const tenantAdminFormInitialValues = {
  userName: '',
  email: '',
}

export const tenantDetailsFormInitialValues = {
  companyName: '',
  address: '',
  state: '',
  country: '',
  city: '',
  zipCode: '',
  contactNumber: '',
  email: '',
  domain: [],
}

export const defaultAddressFormValue = {
  street: '',
  fullAddress: '',
  state: '',
  country: '',
  city: '',
  zipCode: '',
}
